import { autoinject, bindable } from "aurelia-framework";
import { NotificationService, NotificationType } from "../notifications/notification-service";

interface IViewMessage {
    Message: string;
    Type: number;
    Target: string;
}

@autoinject
export class NotificationProxy {
    @bindable message: string;

    constructor(private notificationService: NotificationService) {	}
    
    attached() {
        if (this.message) {
			const messageObject = JSON.parse(this.message) as IViewMessage;
			this.notificationService.push(messageObject.Message, '', this.getMessageType(messageObject.Type));
		}
    }

    getMessageType(type: number): NotificationType {
        switch (type) {
            case 1: return NotificationType.Success;
			case 2: return NotificationType.StickySuccess
            case 3: return NotificationType.Info;
            case 4: return NotificationType.Warning;
            case 5: return NotificationType.Error;
        }
        throw new Error("Invalid message type: " + type);
    }
}
